import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import './i18n'; // Import the i18n configuration
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SessionProvider } from './contexts/SessionContext';
import { Provider } from 'react-redux';
import { reduxStore } from './store/untyppedstore';
import './scss/styles.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={reduxStore}>
      <SessionProvider>
        <App />
      </SessionProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();